import { RootActionTypes } from '../../../stores/types';
import ActionType from '../constants/ActionType';

export default function hideExclusionRuleWorksheet(): RootActionTypes {
  return {
    type: ActionType.HideExclusionRuleWorksheet,
  };
}
